import { Avatar, Typography, useTheme } from "@mui/material"
import { StoreIcon } from "components/icons"
import { useTranslation } from "providers/i18n"

export const ShopPromotionHeader = ({ occupantName = {}, logo = "" }) => {
  const { t } = useTranslation()

  const theme = useTheme()

  const { headerLogo, headerTitle } =
    theme.components?.[`ShopPromotionHeader`].styleOverrides || {}

  return (
    <>
      <Avatar variant="circular-logo" sx={headerLogo} src={logo}>
        <StoreIcon />
      </Avatar>
      <Typography gutterBottom variant="h5" sx={headerTitle}>
        {t(occupantName)}
      </Typography>
    </>
  )
}
